const TOPICS_DATA = [
  { name: '#明星恋情', heat: '1280万', count: '3.2万讨论' },
  { name: '#综艺爆料', heat: '1156万', count: '2.8万讨论' },
  { name: '#影视揭秘', heat: '1023万', count: '2.5万讨论' },
  { name: '#时尚穿搭', heat: '987万', count: '2.1万讨论' },
  { name: '#音乐现场', heat: '865万', count: '1.9万讨论' },
  { name: '#合约纠纷', heat: '754万', count: '1.6万讨论' },
  { name: '#红毯造型', heat: '698万', count: '1.4万讨论' },
  { name: '#直播八卦', heat: '632万', count: '1.3万讨论' },
  { name: '#代言风波', heat: '521万', count: '1.1万讨论' },
  { name: '#片场花絮', heat: '489万', count: '0.9万讨论' },
  { name: '#年度盘点', heat: '412万', count: '0.8万讨论' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            <i className="ri-hashtag text-accent-500 mr-2"></i>话题广场
          </h2>
          <p className="mt-2 text-sm text-foreground-500">热门话题一网打尽，看看大家都在讨论什么</p>
        </div>

        <div className="flex flex-wrap gap-3 justify-center">
          {TOPICS_DATA.map((topic, idx) => (
            <div
              key={idx}
              className="group cursor-pointer"
            >
              <div className="bg-background-50 border border-background-200/60 rounded-2xl px-5 py-3.5 hover:border-primary-200 hover:bg-primary-50/30 transition-all min-w-[140px] text-center">
                <div className={`text-sm font-bold whitespace-nowrap ${
                  idx === 0 ? 'text-primary-500' :
                  idx === 1 ? 'text-accent-600' :
                  idx === 2 ? 'text-secondary-600' :
                  'text-foreground-700'
                } group-hover:text-primary-500 transition-colors`}>
                  {topic.name}
                </div>
                <div className="mt-2 flex items-center justify-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line text-accent-400"></i>
                    {topic.heat}
                  </span>
                  <span>{topic.count}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}